import { Countries } from '../../../utils/countries-enum';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';

export class KoreaManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getKORManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'GlobalModule'
      },
      {
        'key': 'customer-approval-documents',
        'module': 'GlobalModule'
      },
      {
        'key': 'company-names',
        'module': 'GlobalModule'
      },
      {
        'key': 'gst-fee-field',
        'module': 'GlobalModule'
      },
      {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      },
      {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      },
      {
        'key': 'google-address-form',
        'module': 'GlobalModule'
      },
      {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'tax-fee-percent',
        'module': 'GlobalModule'
      },
      {
        'key': 'represented-party-address-google',
        'module': 'KoreaModule'
      }
    ];
    // tslint:disable-next-line: no-use-before-declare
    return this.da.generateManifest(components, Countries.Korea);
  }
}
